import fetchAPI from '../../../utils/fetchAPI';
import { TBiddingClient } from 'types/TBidding';

type TParams = {
  bidId?: number;
  xsrfToken: string;
};

export default async function deleteBid({ bidId, xsrfToken }: TParams): Promise<TBiddingClient> {
  try {
    return await fetchAPI({
      url: '/v/api/delete-bid',
      method: 'DELETE',
      xsrfToken,
      payload: {
        bidId,
      },
    });
  } catch {
    return {};
  }
}
